import { RootState } from 'modules'
import { INewsItemProps } from 'pages/App/components/Sidebar/SidebarInfo/News/NewsItem'

export const selectNews = (state: RootState): Array<INewsItemProps> | null =>
  state.news
